module.exports = __webpack_public_path__ + "img/20201209.51dc8546.png";